export default __webpack_public_path__ + "static/media/Spring.de70f95a.png";